/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Reverse_RtlInputs */



/**
* | output |
* | --- |
* | "Reverse RTL Start / End" |
*
* @param {Subtitle_Export_Reverse_RtlInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_reverse_rtl = /** @type {((inputs?: Subtitle_Export_Reverse_RtlInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Reverse_RtlInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inversion RTL Début / Fin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Umgekehrter RTL-Start/Ende")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizio/fine RTL inverso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обратное начало/конец RTL")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicio/Fin RTL inverso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("反向 RTL 开始/结束")
	if (locale === "ja") return /** @type {LocalizedString} */ ("逆RTL開始/終了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिवर्स आरटीएल प्रारंभ / समाप्ति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Início/Fim da inversão da RTL")
	return /** @type {LocalizedString} */ ("Reverse RTL Start / End")
});